module.exports = __webpack_public_path__ + "static/media/sgd.86b79d6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/proyectos/software/sgd.png
// module id = 247
// module chunks = 0